<template>
  <section class="components-course-dashboard-top py-4">
    <div class="container h-100">
      <div class="row">
        <div class="col-5">
          <div class="box-video box-shadow" @click="playDemo(item)">
            <i class="flaticon-play-1 icon-play"></i>
            <!-- <img src="../assets/img/707962_71f5_4.jpg" class="card-img-top" alt="Javascript Essentials"> -->
            <img class="card-img-top" :src="appUrl.media +'/'+ item.Img" v-if="item.Img">
          </div>
        </div>
        <div class="col-7">
          <div
            class="course-details h-100 d-flex flex-column align-items-start justify-content-between"
          >
            <header>
              <h1 class="font-18 pb-3 mb-4 text-right">{{item.course_title}}</h1>
            </header>
            <!-- <div class="">
                            <div class="form-action form-action-center">
                                <div class="col-12 px-1 text-center">
                                    <button class="font-16 d-inline-block bttn-fill bttn bttn-primary btn-block px-4 py-3" v-ripple  :title="$t('button.continueCourses')">
                                        <i class=" mdi mdi-youtube-creator-studio"></i>
                                        {{$t('button.continueCourses')}}
                                    </button>
                                </div>
                            </div>
            </div>-->
            <!-- <p class="font-16 text-light">
                            4 از 8 مشاهده شده
                        </p>
                        <b-progress :value="75" class="w-100" :variant="'info'"> </b-progress>
                        <p class="font-16 text-light">
                            75% از دوره مشاهده شده ...
            </p>-->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'components-course-dashboard-top',
  computed: {
    item() {
      return this.$store.state.courses.courseDetail
    }
  },
  methods: {
    async playDemo(item) {
      this.isLoading = true
      let { data } = await axios.post(`/lecture/get-free-demo`, { course_id: item.id })
      this.isLoading = false
      if (data.state !== 200) return
      this.playVideo(data.video)
    }
  }
}
</script>
<style lang="less">
@import (reference) "../assets/css/variable.less";
.components-course-dashboard-top {
  .box-clear;
  background-color: #293b2d;
  height: 300px;
  .box-video {
    position: relative;
    cursor: pointer;
    height: 195px;
    overflow: hidden;
    &:before {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.3);
      z-index: 2;
    }
    .icon-play {
      color: #fff;
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      width: 50px;
      height: 50px;
      z-index: 3;
      &:before {
        transition: transform 200ms ease-in-out, box-shadow 400ms ease-in;
        font-size: 26px;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background: fade(@green, 60);
        text-align: center;
        line-height: 50px;
        display: block;
        box-shadow: 0px 0px 5px 0px rgba(1, 1, 1, 0.15);
      }
    }
    &:hover {
      .icon-play {
        &:before {
          transform: scale(1.5);
          box-shadow: 0px 0px 10px 0px rgba(1, 1, 1, 0.4);
        }
      }
    }
  }
  .course-details {
    header {
      h1 {
        .line;
        color: @withe;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/course-dashboard-top.vue